import axios from "./index";
/*首页轮播图*/
const host = "/pc_";

/*省市联动*/
// export const GetCascade = () => axios.get(host + 'API2/serverFiles/data/city.json', null, null, true)
// export const GetCascade = () => axios.get(host + 'API2/serverFiles/data/city.json', null, null, true)
export const GetCascade = () => axios.get("/" + "city.json");

export const GetHomeBanner = () =>
  axios.get(host + "api/BannerApi/GetHomeBanner");
/*首页新闻图*/
export const GetExternalWebpage = () =>
  axios.get(host + "api/NoticeApi/GetExternalWebpage");
/*展厅轮播图*/
export const GetExhibitionBanner = (area) =>
  axios.get(host + "api/BannerApi/GetExhibitionBanner", {
    params: {
      area: area || "BJ",
    },
  });
/*来访目的*/
export const GetVisitPurpose = () =>
  axios.get(host + "api/BaseValueApi/GetVisitPurpose");
/*来访时间*/
export const GetVisitTime = (params) =>
  axios.get(host + "api/BaseValueApi/GetVisitTime", {
    params: params,
  });
/*职业*/
export const GetOccupation = () =>
  axios.get(host + "api/BaseValueApi/GetOccupation");
/*获取所属职业*/
export const GetLMSMainIndustry = () =>
  axios.get(host + "api/BaseValueApi/GetLMSMainIndustry");

/*FAQ*/
export const GetFAQList = (params) => {
  return axios.post(host + "api/FAQApi/GetFAQList", {
    criteria: params,
  });
};
/*FAQ的数据类型*/
export const GetTypeData = () => axios.get(host + "api/FAQApi/GetTypeData");

/*FAQ的数据类型获取的数据*/
export const GetFAQListByType = (type, area) =>
  axios.get(host + "api/FAQApi/GetFAQListByType", {
    params: {
      type: type,
      area: area || "BJ",
    },
  });

/*News新闻列表*/
export const GetNewList = (params) => {
  return axios.post(host + "api/NoticeApi/GetNewList", params);
};

/*New新闻列表里的详情*/
export const Detail = (params) => {
  return axios.get(host + `api/NoticeApi/Detail/${params}`);
};
/*日历：参数是YYYY-MM-DD*/
export const CalendarBusy = (start, end) =>
  axios.get(host + "api/VisitCalendarApi/CalendarBusy", {
    params: {
      startDate: start,
      endDate: end,
    },
  });
/*第四步提交*/
export const Sumbit = (params) =>
  axios.post(host + "api/GroupApplyApi/Sumbit", params);
// 团体预约提交
// export const TeamSumbit = (params) => axios.post(host + "api/VlecTeamAppointmentApi/Submit", params);
export const TeamSumbit = (params) =>
  axios.post(host + "api/VlecTeamAppointmentApi/insert", params);
// /api/VlecTeamAppointmentApi/insert
//团体预约区域列表
export const GetTeamAppointmentCities = () =>
  axios.get(host + "api/VlecTeamAppointmentApi/GetTeamAppointmentCities");
// 获取banner
export const getTopBannerPhoto = (type) =>
  axios.get(host + "api/VlecBannerApi/GetBannerListByType", {
    params: {
      type: type,
    },
  });
/*登录*/
export const LoginService = {
  SendVerifyCode: function (params) {
    return axios.post(host + "api/AccountApi/SendVerifyCode", params);
  },
  Login: function (params) {
    return axios.post(host + "api/AccountApi/Login", params);
  },
  // GetUser: function () {

  //     return axios.get(host + "api/AccountApi/GetUser");
  // }
};
export const ActivityService = {
  GetList: function (params) {
    if (!params.PageIndex) params.PageIndex = 1;
    return axios.get(
      host +
        `api/VlecPublicActivityApi/GetList?PageIndex=${params.PageIndex}&PageSize=${params.PageSize}`,
      params
    );
  },
  Detail: function (id) {
    return axios.get(host + "api/ActivityApi/Detail", { params: { id: id } });
  },
};
export const PublicActivityService = {
  GetList: function (params) {
    if (!params.PageIndex) params.PageIndex = 1;
    return axios.get(
      host +
        `api/VlecPublicActivityApi/GetList?PageIndex=${params.PageIndex}&PageSize=${params.PageSize}`,
      params
    );
  },
  Detail: function (id) {
    return axios.get(host + "api/ActivityApi/Detail", { params: { id: id } });
  },
};



// WEBPACK FOOTER //
// ./src/api/api.js